export const AgGridBorderColor = "var(--ag-border-color)";
